import { Component } from "../base/Component";
import { DomEvent, DomFocusEvent } from "./DomEvent";
import { Event, EventListener } from "./Event";

export interface FocusListener extends EventListener<FocusEvent> {
}

export class FocusEvent extends Event<Component> {
    constructor(component: Component, domEvent?: DomEvent) {
        super(component, domEvent);
    }

    public get domEvent(): DomFocusEvent {
        return super.domEvent as DomFocusEvent;
    }

    public get relatedTarget(): EventTarget {
        return this.domEvent.relatedTarget;
    }
}
